<div class="main">
  <mat-dialog-title>
    <div>Skipped Users</div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div *ngIf="data.personas.length < 1">You have not skipped any user.</div>
    <div class="persona-item" *ngFor="let persona of data.personas">
      <div
        class="image"
        [style.background]="
          persona.image ? persona.image : 'url(images/default-persona.png)'
        "
      ></div>
      <div class="info">
        <div class="info-heading">{{ persona.name }}</div>
        <div class="info-subtitle">{{ persona.description }}</div>
      </div>
      <div>
        <rr-icon name="eye"></rr-icon>
      </div>
      <div class="tinder-btn no-match" (click)="changeSkipped(persona, false)">
        <div class="tinder-btn-inner">
          <svg
            width="40"
            height="40"
            viewBox="0 0 87 87"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29 54.375H58M32.625 32.625H32.6613M54.375 32.625H54.4113M79.75 43.5C79.75 63.5203 63.5203 79.75 43.5 79.75C23.4797 79.75 7.25 63.5203 7.25 43.5C7.25 23.4797 23.4797 7.25 43.5 7.25C63.5203 7.25 79.75 23.4797 79.75 43.5Z"
              stroke="#C73A3A"
              stroke-opacity="0.8"
              stroke-width="7.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div class="tinder-btn match" (click)="changeSkipped(persona, true)">
        <div class="tinder-btn-inner">
          <svg
            width="40"
            height="40"
            viewBox="0 0 87 87"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29 50.75C29 50.75 34.4375 58 43.5 58C52.5625 58 58 50.75 58 50.75M32.625 32.625H32.6613M54.375 32.625H54.4113M79.75 43.5C79.75 63.5203 63.5203 79.75 43.5 79.75C23.4797 79.75 7.25 63.5203 7.25 43.5C7.25 23.4797 23.4797 7.25 43.5 7.25C63.5203 7.25 79.75 23.4797 79.75 43.5Z"
              stroke="#067A57"
              stroke-opacity="0.8"
              stroke-width="7.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <rr-btn type="Primary" tone="brand" (btnclick)="done()">Done</rr-btn>
  </mat-dialog-actions>
</div>
